/* Development-only logging: silent in production builds. */
export function devWarn(...args) {
    if (process.env.NODE_ENV === "development") console.warn(...args);
}
